import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

// Unifiber staff only (SYSTEM_ADMIN or UNIFIBER_OPERATOR) — excludes EXTERNAL_OPERATOR_USER.
// Same pattern as AdminRoute.tsx, swapping isAdmin for isInternal.
export function InternalRoute() {
  const { isInternal } = useAuth();

  if (!isInternal) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
